import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';

class PaymentRoute extends PureComponent {
  static propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  };

  render() {
    const { loggedIn, component: Component, ...other } = this.props;

    return (
      <Route
        {...other}
        render={props => {
          return <Component {...props} />;
        }}
      />
    );
  }
}

const selector = ({ auth: { loggedIn } }) => ({
  loggedIn,
});

export default withRouter(connect(selector)(PaymentRoute));
